// import Feature from 'ol/Feature';
import Layer from 'ol/layer/Layer';
import Point from 'ol/geom/Point';
import WKT from 'ol/format/WKT';
// import { WGisEngine } from './wgis.engine';
import { EngineType,
  FieldsInterface,
  MapEngineOptions,
  BaseEngine,
  WGisFeatureInfo,
  WGisFeatureInterface,
  WGisServiceInterface } from './wgis.utils';
import { WGisSelectableEngine } from './wgis.selectableengine';

import Collection, { CollectionEvent, Options as CoolectionOptions } from 'ol/Collection';
// import { Map } from 'ol';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';


export class WGisVectorEngine extends WGisSelectableEngine implements BaseEngine {
  source: VectorSource = undefined;
  featurecollection: Collection<WGisFeatureInterface> = undefined;

  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.createLayer();
  }

  createLayer() {
    this.type = EngineType.VECTOR;
    this.featurecollection = new Collection([], { unique: true });
    this.source = new VectorSource({
      features: this.featurecollection
    });
    this.oLayer = new VectorLayer({
      source: this.source
    });
    this.registerLayer();

  }

  // OVERIDE ME
  saveSelection(): void { }
  getSelection(): void { }

  clearSelection(): void {
    this.source.clear();
  }


  addFeatureToSelection(feature: WGisFeatureInterface) {
    this.source.addFeature(feature);
  }

  removeFeatureFromSelection(feature: WGisFeatureInterface) {
    this.source.removeFeature(feature);
  }
}
